/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import moment from 'moment';
import { Maybe } from '@codegrade/maybe';
import { ApiResult } from './ApiResult';
const RETRYABLE_METHODS = new Set([
    'GET',
    'HEAD',
    'OPTIONS',
    'PUT',
    'DELETE',
]);
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function makeConfig(overrideConfig) {
    return Object.freeze({
        base: 'https://app.codegra.de',
        maxTries: 2,
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        shouldRetry(request, response) {
            const { status } = response;
            return (RETRYABLE_METHODS.has(request.method) &&
                ((status >= 500 && status < 600) || status === 429));
        },
        maxSleepTime: moment.duration(30, 'seconds'),
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        getSleepTime(tryN) {
            const delay = 2 ** tryN * 500;
            const randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
            const maxDelay = this.maxSleepTime;
            const sleepTime = moment.duration(delay + randomSum);
            if (maxDelay.asMilliseconds() < sleepTime.asMilliseconds()) {
                return maxDelay.clone();
            }
            return sleepTime;
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        makeResult(result, value) {
            return ApiResult.fromResponseAndValue(result, value);
        },
        processError: Maybe.empty(),
        token: Maybe.empty(),
        headers: Maybe.empty(),
        fetch: (...args) => fetch(...args),
        ...overrideConfig,
    });
}
